import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../profile/styles.css';

export default function ProfileArtistHelpLimitedEditionsPage() {
  const t = useTranslations('artist_help.limited_editions');
  const [openSections, setOpenSections] = useState({
    whatAreLimitedEditions: false,
    whoCanActivate: false,
    whyLimitedEditionsMatter: false,
    incomeRevenueStructure: false,
    howProduced: false,
    qualityRepresentation: false,
    requirementsActivation: false,
    exclusivityLifecycle: false,
    keyPerspective: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/artist-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('whatAreLimitedEditions')}
            aria-expanded={openSections.whatAreLimitedEditions}
          >
            <h2>{t('sections.what_are_limited_editions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.whatAreLimitedEditions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whatAreLimitedEditions && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.what_are_limited_editions.p1')}</p>
              <p>{t('sections.what_are_limited_editions.p2')}</p>
              <p>{t('sections.what_are_limited_editions.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('whoCanActivate')}
            aria-expanded={openSections.whoCanActivate}
          >
            <h2>{t('sections.who_can_activate.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.whoCanActivate ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whoCanActivate && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.who_can_activate.p1')}</p>
              <p>{t('sections.who_can_activate.p2')}</p>
              <ul>
                <li>{t('sections.who_can_activate.list_1')}</li>
                <li>{t('sections.who_can_activate.list_2')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('whyLimitedEditionsMatter')}
            aria-expanded={openSections.whyLimitedEditionsMatter}
          >
            <h2>{t('sections.why_limited_editions_matter.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.whyLimitedEditionsMatter ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whyLimitedEditionsMatter && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.why_limited_editions_matter.p1')}</p>
              <ul>
                <li>{t('sections.why_limited_editions_matter.list_1')}</li>
                <li>{t('sections.why_limited_editions_matter.list_2')}</li>
                <li>{t('sections.why_limited_editions_matter.list_3')}</li>
              </ul>
              <p>{t('sections.why_limited_editions_matter.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('incomeRevenueStructure')}
            aria-expanded={openSections.incomeRevenueStructure}
          >
            <h2>{t('sections.income_revenue_structure.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.incomeRevenueStructure ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.incomeRevenueStructure && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.income_revenue_structure.p1')}</p>
              <ul>
                <li>{t('sections.income_revenue_structure.list_1')}</li>
                <li>{t('sections.income_revenue_structure.list_2')}</li>
                <li>{t('sections.income_revenue_structure.list_3')}</li>
              </ul>
              <p>{t('sections.income_revenue_structure.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('howProduced')}
            aria-expanded={openSections.howProduced}
          >
            <h2>{t('sections.how_produced.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.howProduced ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.howProduced && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.how_produced.p1')}</p>
              <ul>
                <li>{t('sections.how_produced.list_1')}</li>
                <li>{t('sections.how_produced.list_2')}</li>
                <li>{t('sections.how_produced.list_3')}</li>
              </ul>
              <p>{t('sections.how_produced.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('qualityRepresentation')}
            aria-expanded={openSections.qualityRepresentation}
          >
            <h2>{t('sections.quality_representation.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.qualityRepresentation ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.qualityRepresentation && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.quality_representation.p1')}</p>
              <ul>
                <li>{t('sections.quality_representation.list_1')}</li>
                <li>{t('sections.quality_representation.list_2')}</li>
                <li>{t('sections.quality_representation.list_3')}</li>
              </ul>
              <p>{t('sections.quality_representation.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('requirementsActivation')}
            aria-expanded={openSections.requirementsActivation}
          >
            <h2>{t('sections.requirements_activation.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.requirementsActivation ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.requirementsActivation && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.requirements_activation.p1')}</p>
              <ul>
                <li>{t('sections.requirements_activation.list_1')}</li>
                <li>{t('sections.requirements_activation.list_2')}</li>
                <li>{t('sections.requirements_activation.list_3')}</li>
                <li>{t('sections.requirements_activation.list_4')}</li>
                <li>{t('sections.requirements_activation.list_5')}</li>
              </ul>
              <p>{t('sections.requirements_activation.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('exclusivityLifecycle')}
            aria-expanded={openSections.exclusivityLifecycle}
          >
            <h2>{t('sections.exclusivity_lifecycle.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.exclusivityLifecycle ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.exclusivityLifecycle && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.exclusivity_lifecycle.p1')}</p>
              <ul>
                <li>{t('sections.exclusivity_lifecycle.list_1')}</li>
                <li>{t('sections.exclusivity_lifecycle.list_2')}</li>
              </ul>
              <p>{t('sections.exclusivity_lifecycle.p2')}</p>
              <ul>
                <li>{t('sections.exclusivity_lifecycle.list_3')}</li>
                <li>{t('sections.exclusivity_lifecycle.list_4')}</li>
              </ul>
              <p>{t('sections.exclusivity_lifecycle.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('keyPerspective')}
            aria-expanded={openSections.keyPerspective}
          >
            <h2>{t('sections.key_perspective.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.keyPerspective ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.keyPerspective && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.key_perspective.p1')}</p>
              <p>{t('sections.key_perspective.p2')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
